import { PriceValue } from '@secretescapes/cauldron';
import styled, {
  Scale,
  TypographyVariant,
  typographyVariantProperties,
} from '@secretescapes/falcon';
import { CommonStyledProps, mediaQuery } from '@utils/styles.utils';

interface TabContainerProps extends CommonStyledProps {
  isSelected?: boolean;
  borderRadiusPosition?: 'left' | 'right';
}

export const TabContainer = styled('div')<TabContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${Scale.xxxs};
  padding: ${Scale.xs} ${Scale.m};
  cursor: pointer;
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.color.white : theme.color.grey05};

  ${({ borderRadiusPosition, isSelected, theme, isMobile }) => {
    const oppositePosition = borderRadiusPosition === 'left' ? 'right' : 'left';
    return isSelected
      ? `
        border-bottom: ${theme.color.white} 1px solid;
        border-${borderRadiusPosition}: ${theme.color.grey10} 1px solid;
        border-top-${oppositePosition}-radius: ${isMobile ? Scale.xxs : 0};
      `
      : `
        border-bottom: ${theme.color.grey10} 1px solid;
        border-top-${oppositePosition}-radius: ${isMobile ? Scale.xxs : 0};
        box-shadow: ${
          (isMobile && borderRadiusPosition === 'right') ||
          (!isMobile && borderRadiusPosition === 'left')
            ? 'inset -1px -1px 2px ' + theme.color.grey10
            : 'inset 1px -1px 2px ' + theme.color.grey10
        };
      `;
  }}

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    flex: initial;
    padding: ${Scale.xs} ${Scale.l};
    ${({ borderRadiusPosition }) =>
      borderRadiusPosition && `border-top-${borderRadiusPosition}-radius: ${Scale.xxs}`};
    border: none;
  }
`;

export const TabHeaderContainer = styled('div')`
  display: flex;
  align-items: center;
  gap: ${Scale.xxs};
`;

export const TabContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xxs};
  // Ensures that ATOL badge is aligned with the price value
  min-height: 26px;

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    align-items: center;
    flex-direction: row;
  }
`;

export const TabPriceValue = styled(PriceValue)`
  flex-direction: column;

  /* Override tooltip z-index */
  span {
    z-index: 3;
  }

  h4 {
    font-size: ${typographyVariantProperties[TypographyVariant.b3Bold].desktopFontSize};
  }

  p {
    font-size: ${typographyVariantProperties[TypographyVariant.micro].desktopFontSize};
  }

  @media ${mediaQuery.tablet}, ${mediaQuery.desktop} {
    flex-direction: row;
    align-items: baseline;
  }
`;
